<template>
    <figure class="thumbnail-image-container image mr-3" :class="imageClass">
        <a v-if="url" :href="url">
            <img
                class="thumbnail-image-centered"
                :class="imageClass"
                v-if="thumbnailImageUrl"
                loading="lazy"
                :src="thumbnailImageUrl"
                :alt="fullName + ' logo'"
            />
            <img v-else loading="lazy" src="https://martialmatch.com/img/no-image.png" class="thumbnail-image-centered" alt="No logo" />
        </a>
        <span v-else>
            <img
                class="thumbnail-image-centered"
                :class="imageClass"
                v-if="thumbnailImageUrl"
                loading="lazy"
                :src="thumbnailImageUrl"
                :alt="fullName + ' logo'"
            />
            <img v-else loading="lazy" src="https://martialmatch.com/img/no-image.png" class="thumbnail-image-centered" alt="No logo" />
        </span>
    </figure>
</template>

<script setup lang="ts">
    import { computed } from "vue";

    const props = defineProps<{
        thumbnailImageUrl: string | null;
        fullName: string;
        size: "48x48" | "64x64";
        url?: string | null | undefined;
    }>();

    const imageClass = computed(() => {
        if (props.size === "48x48") {
            return "is-48x48";
        }

        return "";
    });
</script>

<style scoped></style>
